import { z, ZodIssueCode } from 'zod';
import { ErrorCode } from './codes.js';

// WHY: the wire `code` is a closed union — Zod's own issue codes (the
// fall-through for non-domain validation failures) plus our `ErrorCode`
// values that schemas can attach via `.refine(_, { params: { code } })`.
// Pinning the union here keeps the backend filter (`pickIssueCode`) and
// every client-side branch on `issues[].code` honest: an arbitrary string
// at this seam would silently bypass the whitelist enforced server-side.
export const IssueCodeSchema = z.union([z.nativeEnum(ZodIssueCode), z.nativeEnum(ErrorCode)]);

export const ValidationIssueSchema = z
  .object({
    path: z.array(z.union([z.string(), z.number()])),
    message: z.string(),
    code: IssueCodeSchema.optional(),
  })
  .strict();

export const ApiErrorSchema = z
  .object({
    code: z.nativeEnum(ErrorCode),
    message: z.string(),
    issues: z.array(ValidationIssueSchema).optional(),
    meta: z.record(z.unknown()).optional(),
    reqId: z.string().optional(),
  })
  .strict();

export type ValidationIssue = z.infer<typeof ValidationIssueSchema>;
export type ApiError = z.infer<typeof ApiErrorSchema>;
